module.exports = __webpack_public_path__ + "static/media/valkpay.c633c404.png";